import * as React from 'react';
import { FormContext } from './FormContext';
import s from '../../RequestCall.scss';
import classNames from 'classnames';
import { Button, Loader } from 'wix-style-react';
import { useTranslation } from 'react-i18next';
import { usePageModeContext } from '../../../../providers/PageMode/PageMode.provider';

export const FormSubmitButton: React.FC = () => {
  const { isSubmitting } = React.useContext(FormContext);
  const { t } = useTranslation();
  const { theme } = usePageModeContext();
  return (
    <Button
      type='submit'
      size='large'
      className={classNames(s.formButtons, s.submitButton, theme)}
      dataHook='form-submit-button'
    >
      {isSubmitting ? (
        <Loader dataHook='submit-loader' size='tiny' />
      ) : (
        t('premium_plan.business_enterprise.request_call_form.submit_button')
      )}
    </Button>
  );
};
